import {
  Box,
  Typography,
  Avatar,
  InputBase,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ImgPath from "Constants/Imgs";
import ColorData from "Components/CstmTheme/ColorData";
import { useDispatch } from "react-redux";
import { clearUser } from "../../Redux/User/Action";
import { useSelector } from "react-redux";
import { UserInitialStateType } from "DataTypes/Redux";
import SubTopBar, { menuItems } from "./SubTopBar";
import dayjs from 'dayjs';
import { useCallback, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import MobileDrawer from "Components/commonComponents/HederDrawer";
import SidebarDrawer from "Components/commonComponents/sidebarDrawer";
import { handleNavigation } from "Components/Header";
import { navItems } from "./Sidebar";

const Topbar = ({ onMenuClick }: { onMenuClick?: () => void }) => {
  const theme = useTheme();
  const [expandedItems, setExpandedItems] = useState<{ [key: string]: boolean }>({});
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const dispatch = useDispatch();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [sidebarDrawerOpen, setSidebarDrawerOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));  
  const handleLogout = async () => {
    localStorage.clear();
    dispatch(clearUser() as any);
    window.location.href = "/home.html";
  };
  const currentDateTime = dayjs().format('D MMM, YYYY / h:mmA');
  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
    // Reset expanded items when drawer closes for better UX
    setExpandedItems({});
  }, []);
  const handleExpandClick = (id: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };


  return (
    <Box
      sx={{
        bgcolor: "white",
        boxShadow: 2,
        position: "sticky",
        top: 0,
        zIndex: 1000,
        minHeight: myInfo?.userType === "USER" ? "140px" : "80px", // Dynamic height based on user type
      }}
      className="topbar-box"
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3 },
          py: { xs: 1, sm: 2 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          minHeight: "80px", // Fixed height for main header content
        }}
      >
        {/* Left Section - Logo + Welcome */}
        <Box display="flex" alignItems="center" gap={2}>
          <IconButton
            onClick={onMenuClick}
            sx={{ display: { xs: "block", md: "none" } }}
          >
            {/* <img src={ImgPath.ReviewIcon} alt="User" /> */}
            {/* <Avatar src="/assets/images/dashboard-icons/profile-img.png" /> */}
          </IconButton>

          {/* {isMobile && ( */}
          <>
            {isMobile && (
              <IconButton
                onClick={() => setSidebarDrawerOpen(true)}
                sx={{ color: ColorData.text.primary }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <Avatar src={myInfo?.profileImageUrl || "/assets/images/dashboard-icons/profile-img.png"} />
            <Typography>
              Welcome,{" "}
              <strong style={{ color: ColorData.heading.main }}>
                {myInfo.firstname}
              </strong>
            </Typography>
          </>
          {/* )} */}
        </Box>

        {/* Center Section - Search */}
        {!isMobile && (<Box
          position="relative"
          mx="auto"
          sx={{ mt: { xs: 1.5, md: 0 }, width: { xs: "100%", md: 350 } }}
        >
          <SearchIcon
            sx={{
              position: "absolute",
              top: "50%",
              left: 10,
              transform: "translateY(-50%)",
              color: "#a24857",
            }}
          />
          <InputBase
            placeholder="Search for ..."
            sx={{
              bgcolor: "#F7F6F9",
              pl: 5,
              pr: 2,
              py: 0.8,
              borderRadius: 2,
              width: "100%",
              fontSize: 14,
            }}
          />
        </Box>
        )}

        {/* Right Section - Date, Language, Logout */}
        {!isMobile && (
          <Box
            display="flex"
            alignItems="center"
            gap={2}
            sx={{ mt: { xs: 1.5, md: 0 } }}
          >
            <Typography fontWeight={500} fontSize={"15px"}>
              {currentDateTime}
            </Typography>
            <Typography sx={{ cursor: "pointer" }}>ENG ▾</Typography>
            <Box display="flex" alignItems="center" gap={1}>
              <IconButton
                sx={{
                  cursor: "pointer",
                  boxShadow: "none",
                  "&:hover": {
                    boxShadow: "none",
                    backgroundColor: "transparent",
                  },
                }}
                onClick={handleLogout}
              >
                <ImgPath.LogoutIcon />
                <Typography sx={{ ml: 1 }}>Logout</Typography>
              </IconButton>
            </Box>


          </Box>
        )}

        {isMobile && (
          <IconButton
            onClick={() => setDrawerOpen(true)}
            sx={{ color: ColorData.text.primary }}
          >
            <MenuIcon />
          </IconButton>
        )}

      </Box>
      {myInfo?.userType === "USER" && (
        <Box sx={{ 
          borderTop: "1px solid #e0e0e0",
          bgcolor: "white",
        }}>
          <SubTopBar />
        </Box>
      )}


      <MobileDrawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        navItems={menuItems}
        expandedItems={expandedItems}
        onExpandClick={handleExpandClick}
        onNavigate={(item: string) => {
          handleNavigation(item);
          handleDrawerClose(); // Close drawer after navigation
        }}
      />

      <SidebarDrawer open={sidebarDrawerOpen} onClose={() => setSidebarDrawerOpen(false)} navItems={navItems} handleLogout={handleLogout} />


    </Box>
  );
};

export default Topbar;
